// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-button.btn-query{background-color:transparent!important;color:#e60012!important;border-color:#e60012!important}.el-button.btn-query:focus:not(.is-disabled),.el-button.btn-query:hover:not(.is-disabled){color:#fff!important;background-color:#e60012!important}.el-button.btn-query.is-disabled{opacity:.4}", ""]);
// Exports
module.exports = exports;
